import React from 'react';

function HeartCardIcon() {
    return (
        <svg
            style={{ minWidth: '1.5rem' }}
            width='24' height='20' viewBox='0 0 24 20'
            fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M11.566 3.83461L12 4.59352L12.434 3.83461C13.3426 2.24591 15.0324 0.554962 17.625 0.554962C20.954 0.554962 23.5 3.0917 23.5 6.48265C23.5 8.30203 22.714 9.85787 21.2473 11.4906C19.7905 13.1125 17.7104 14.7585 15.1619 16.7753L15.0455 16.8673C13.11 18.3977 12.4812 18.9097 12.0528 19.2585C12.0348 19.2732 12.0171 19.2876 11.9998 19.3017C11.9568 19.2668 11.9137 19.2317 11.8694 19.1956C11.4274 18.8359 10.8571 18.3717 8.95447 16.8673L8.83813 16.7753C6.28963 14.7585 4.20953 13.1125 2.75266 11.4906C1.28599 9.85787 0.5 8.30203 0.5 6.48265C0.5 3.09166 3.04599 0.554962 6.375 0.554962C8.96761 0.554962 10.6574 2.24591 11.566 3.83461Z' stroke='black' strokeOpacity='0.3' />
        </svg>
    );
}

export default React.memo(HeartCardIcon);
